define('../app/fukit/view/block/toggle.column.view',['require','exports','module','underscore','uikit/uikit','../../behavior/resolve.options.behavior','../../behavior/invoke.model.method.on.event.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                                = require('underscore'),
      UIKit                            = require('uikit/uikit'),
      ResolveOptionsBehavior           = require('../../behavior/resolve.options.behavior'),
      InvokeModelMethodOnEventBehavior = require('../../behavior/invoke.model.method.on.event.behavior');

  var ToggleColumnView = UIKit.Checkbox.extend({
    options: _.extend({}, UIKit.Checkbox.prototype.options, {
      polar: true,
      toggle: true,
    }),

    triggers: {
      click: {
        event: 'press',
        stopPropagation: true,
      },
    },

    behaviors: {
      SaveOnToggleBehavior: {
        behaviorClass: InvokeModelMethodOnEventBehavior,
        eventName: 'change',
        method: 'save',
      },
    },
  });
  module.exports = ToggleColumnView;
});

